import { Action, CategoriesStateInterface } from 'shared/interface';
import { FETCH_CATEGORIES, FETCH_POPULAR_CATEGORIES } from 'shared/store/action-types';

const initialState: CategoriesStateInterface = {
	all: [],
	popular: [],
	filtered: [],
};

export const CategoriesReducer = (state: CategoriesStateInterface = initialState, action: Action): CategoriesStateInterface => {
	switch (action.type) {
		case FETCH_CATEGORIES:
			return { ...state, ...action.payload };
		case FETCH_POPULAR_CATEGORIES:
			return { ...state, ...action.payload };
		default:
			return state;
	}
};
